const Community = () => {
    return (
        <section className="App-section" id="comunidad">
          <h2>Comunidad</h2>
          <p>
            Calpecoin sólo es una blockchain, pero puede ser mucho más. Puede quedarse en solo un juguete. 
            También puede una fuente de conocimiento, innovación y riqueza para el pueblo.
          </p>
          <p>
            En un entorno descentralizado, la comunidad tiene la oportunidad y responsabilidad de elegir.
            Así que queda en nuestras manos darle el futuro que se merece.
            </p>
          <h3>Contribuye con tus habilidades</h3>
          <p>
            Hay "todo un pueblo" por construir. Utiliza tus habilidades para contribuir y ayudar a crear valor dentro del ecosistema.
          </p>
          <p>
            Aunque es muy útil para construir los cimientos, no es necesario tener conocimientos de programación para participar. Hay multitud de cosas por hacer 
            y no todas requieren conocimientos técnicos.
          </p>
          <h3>Explora el ecosistema descentralizado de Calpe</h3>
          <p>
            Propiedad y valor, pero también comunicaciones e identidad.
          </p>
          <p>
            No todo es blockchain. Además de Calpecoin, estamos preparando aplicaciones y herramientas descentralizadas que ni están solo basadas en cadenas de bloques ni 
            tienen necesariamente fines económicos. Redes sociales federadas, mensajería y web descentralizada, streaming de audio y vídeo p2p...
          </p>
          <p>
            Queremos que Calpe sea un pueblo pionero en la era de la Web3.
          </p>
          <h3>Únete a la comunidad</h3>
          <p>Puedes unirte a nuestro grupo de Telegram mientras vayas familiarizandote con las herramientas de la Web3.</p>
          <p>
            Si quieres dar un paso más, prueba nuestra sala en matrix.org, el nuevo protocolo de comunicación descentralizado que hereda lo mejor del protocolo XMPP y la criptografía de Signal.
          </p>
          <p>
            <a
              href="https://t.me/+H4Dj7P9F36M3ZjU0"
              target="_blank"
              rel="noreferrer"
            >
              Únete a Telegram
            </a>
          </p>
          <p>
            <a
              href="https://matrix.to/#/!mMquqKoHNjbQyDHjJd:matrix.org?via=matrix.org"
              target="_blank"
              rel="noreferrer"
            >
              Únete a matrix.org
            </a>
          </p>
        </section>
    )
}

export default Community